import Api from "../ApiUtility/Api";


class UsersDS {
  constructor() {
    this.api = new Api();
  }

  //LOGIN POST

  RM_Referral_Source_ADD(requestData) {
    return this.api.postAPI(requestData, '/dev/RM_Referral_Source_ADD')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }


}

export default UsersDS;